<template>
  <div v-if="$auth.authenticated" class="user">
    <div class="photo">
      <div class="avatar-circle"><span>{{ initials }}</span></div>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.prevent="toggleMenu" href="#">
         <span>{{ name }}<b class="caret"/></span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <router-link :to="{ name: 'UserProfile' }">
                <span class="sidebar-mini-icon"><i class="nc-icon nc-badge"/></span>
                <span class="sidebar-normal">{{ $t('My Account') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ChangePassword' }">
                <span class="sidebar-mini-icon"><i class="nc-icon nc-key-25"/></span>
                <span class="sidebar-normal">{{ $t('Change Password') }}</span>
              </router-link>
            </li>
            <li>
              <a href="#" @click="confirmAndLogout">
                <span class="sidebar-mini-icon"><i class="fas fa-power-off"/></span>
                <span class="sidebar-normal">{{ $t('Logout') }}</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'

  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: true
      }
    },
    computed: {
      name () {
        const user = this.$auth.user
        const firstName = user.firstName.trim() || ''
        const lastName = user.lastName.trim() || ''
        return `${[firstName, lastName].join(' ')}`
      },
      initials () {
        const user = this.$auth.user
        const firstName = user.firstName.trim().slice(0,1) || ''
        const lastName = user.lastName.trim().slice(0,1) || ''
        return `${[firstName, lastName].join('')}`
      }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      confirmAndLogout () {
        this.$emit('logout', true)
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }

  .sidebar .user .info .caret {
    position: relative;
    top: 0;
    right: -10px;
  }
</style>
